
<template>
  <span>

    <a href="#" class="btn skin primary-button" @click="openModal" style="color:inherit;">Dall-E</a>

    <modal-in-front v-bind:title="map" ref="thisModal" size="modal-md">
      <div style="margin:auto;overflow:visible;position:relative">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-6">
              <input v-model="tag"
                     placeholder="Search for photos"
                     type="text"
                     class="form-control">
            </div>
            <div class="col-12 col-md-6">
              <button type="submit"
                      class="btn btn-success"
                      @click.prevent="search">
                Go
              </button>
              <button v-if="image != null" type="submit"
                      class="btn btn-success"
                      @click.prevent="variant">
                Variant
              </button>
              <button v-if="image != null" type="submit"
                      class="btn btn-success"
                      @click.prevent="use">
                Use
              </button>
            </div>
            <!--<div class="col-4 mt-3 mt-md-0">
    <select class="form-control" v-model="size">
      <option value="landscape" selected>landscape</option>
      <option value="portrait">portrait</option>
      <option value="square">square</option>
    </select>
  </div>-->
            <div class="col-12">

              <div class="wrapper" style="max-height:400px;overflow-y:scroll;">
                <p v-if="loading" class="text-centered">
                  Loading, Dall-e takes a while so be patient...
                </p>
                <ul v-else class="image-card-grid">
                  <image-card @onclicked="onclicked" v-for="im in images"
                              :key="im.id"
                              :image="im" v-bind:selected="im == image" />
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </modal-in-front>
  </span>

</template>

<script>

  import ModalInFront from "../modals/modal-in-front.vue";
  import axios from 'axios';
  let jsonpAdapter = require('axios-jsonp');
  import ImageCard from "../imagehandling/Image-Card";
  
  export default {
    name: 'dall-e-button',
    components: {
      ModalInFront,
      ImageCard
    },
    props: {
      
    },
    data() {
      return {
        api_key: "563492ad6f9170000100000195019ab8fe234eb5bbb68662dd10bd9e",
        loading: false,
        tag: '',
        images: [],
        infoIconUrl : "https://developers.google.com/maps/documentation/javascript/examples/full/images/info-i_maps.png",
        jsonpAdapter,
        size: 'landscape',
        image: null,
      }
    },
    methods: {
      onclicked(image) {
        this.image = image;
      },
      openModal() {
        this.$refs.thisModal.open();
      },
      getId() {
        return this._uid;
      },
      use() {
        
        if (this.image != null)
          this.$emit("onclicked", this.image);
      },
      variant() {
        this.loading = true;
        this.fetchImageVariant(this.image.id);
      },
      search() {
        this.loading = true;
        this.fetchImages();
      },
      async fetchImageVariant(id) {
        const headers = new Headers();
        const request = new Request(
          "/api/dalle/GetVariant?imageId=" + id,
          {
            method: "GET",
            headers,
          }
        );
        const res = await fetch(request);
        var responseData = await res.json();
        var tmpPhotos = [];
        for (var i = 0; i < responseData.Data.length; i++) {
          tmpPhotos.push(
            {
              "id": responseData.Data[i].Id,
              "title": this.tag + (i + 1),
              "ownername": "Dall-E",
              "datetaken": "",
              "views": "",
              "url_n": responseData.Data[i].Url,
            }
          )
        }
        this.images = tmpPhotos;
        this.loading = false;

      },

      async fetchImages() {
        const headers = new Headers();
        const request = new Request(
          "/api/dalle/get?query=" + this.tag + "&size=" + this.size,
          {
            method: "GET",
            headers,
          }
        );
        const res = await fetch(request);
        var responseData = await res.json();
        var tmpPhotos = [];
        for (var i = 0; i < responseData.Data.length; i++) {
          tmpPhotos.push(
            {
              "id": responseData.Data[i].Id,
              "title": this.tag + (i+1),
              "ownername": "Dall-E",
              "datetaken": "",
              "views": "",
              "url_n": responseData.Data[i].Url,
            }
          )
        }
        this.images = tmpPhotos;
        this.loading = false;

      },
     
    },
    created() {

    },
    mounted() {
      //window.jsonFlickrApi = this.displayImages;
    }
  }
</script>



<style scoped>


  .image-card-grid {
    list-style: none;
    margin: .5rem 0;
    padding: 0;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/imagehandling/dall-e-button.vue